enum StaticFilesReference {
      EngineeringInsuranceInstructions = 'ENGINEERING_INSURANCE_INSTRUCTIONS'
}

export default StaticFilesReference;
